import { defineStore } from "pinia";
import Services from '@/services/adminServices'
import { mapAdmin } from '@/helpers/mapFuncs'

export const useAdminsStore = defineStore("admins", {

state:()=>({
    admin: {},
    admins: [],
}),
getters : {
    getAdmin() {
        return mapAdmin(this.admin)
    },
    getAdmins() {
        return this.admins.map(mapAdmin)
    }
},
actions : {
    /** Start Sets */
    setAdmin(admin) {
        this.admin = admin
    },
    setAdmins(admins) {
        this.admins = admins
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setAdmin(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setAdmins(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setAdmins(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.admins.push(response.data.data)
            return mapAdmin(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.admins[this.admins.findIndex((x)=>x.id == id)] = response.data.data
            return mapAdmin(response.data.data)
        })
    },
    resetPassword(id, data){
        return Services.resetPassword(id, data)
        .then((response)=>{
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.admins = this.admins.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});